<template>
  <v-form class="my-10">
    <v-container>
      <v-row>
        <v-col clos="12" md="4" sm="12">
          <v-text-field
            v-model="FileName"
            label="File Name"
            required
          ></v-text-field>
        </v-col>
        <v-col clos="12" md="5" sm="0"></v-col>
        <v-col clos="12" md="3" sm="12">
          <v-select
            v-model="category"
            :items="['Report', 'Study', 'Data', 'Results']"
            label="Category"
            outlined
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <VueFileAgent
          class="drop-zone"
          :multiple="false"
          v-model="fileRecords"
          :deletable="true"
          :editable="true"
        ></VueFileAgent>
      </v-row>
      <v-row class="d-flex justify-center" align="center">
        <v-btn class="font-ajust white--text" color="#238EF6"> Upload </v-btn>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    FileName: "",
    category: "",
    fileRecords: undefined,
  }),
  mounted() {
    document.getElementsByClassName("help-text")[0].innerHTML =
      "Drag and drop a file here or <br><button class='drop-btn'>Choose file</button>";
  },
};
</script>

<style>
.font-ajust {
  text-transform: capitalize !important;
  width: 200px !important;
  font-size: 1.5rem !important;
}
.drop-zone {
  width: 100%;
  background: #f2f2f2;
  margin-bottom: 10px;
}
.drop-zone span {
  font-size: 1rem !important;
}

.file-preview-wrapper .grid-box-item .grid-block .file-preview-new {
  padding: 0 !important;
}
.vue-file-agent .file-preview-wrapper::before {
  display: none !important;
}
.drop-zone .vue-file-agent.file-input-wrapper {
  border: 2px dashed var(--firts-color);
}
.drop-btn {
  background: var(--firts-color);
  color: white;
  border-radius: 10px;
  padding: 5px;
}
</style>